import script from "./Episodes.vue?vue&type=script&setup=true&lang=js"
export * from "./Episodes.vue?vue&type=script&setup=true&lang=js"

import "./Episodes.vue?vue&type=style&index=0&id=2cf2cdf7&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cf2cdf7"]])

export default __exports__